import { GetLetterPostscriptsDocument, GetLetterPostscriptsQuery } from "../../../../types/graphql";
import { AnyQueryArgs, ProviderRequestMethod, GetListQueryResolver, IRecordObject } from "../types";

export interface ILetterPostscriptRecord extends IRecordObject {
  label: string;
}

const listQuery: GetListQueryResolver<GetLetterPostscriptsQuery, ILetterPostscriptRecord> = () => ({
  query: GetLetterPostscriptsDocument,
  variables: {},
  parseResponse: ({ data }) => ({
    data: data.letterPostscripts.map(({ id, label }) => ({ id, label: label || "" })),
    total: data.letterPostscripts.length,
  }),
});

export const letterPostscriptQuery = (fetchType: ProviderRequestMethod): AnyQueryArgs => {
  switch (fetchType) {
    case ProviderRequestMethod.GET_LIST:
      return listQuery();
    default:
      throw new Error(`fetchType ${fetchType} not recognised for calls`);
  }
};
